<template>
    <painel-component :items="itemsOne">
        <form>
            <row-component>
                <row-col-component class-row-col="col-xxl-5 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                    <label>Nome:</label>
                    <input-component type-input="text" v-model="formData.name"/>
                </row-col-component>

                <row-col-component class-row-col="col-xxl-5 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                    <label>Status:</label>
                    <Multiselect v-model="formData.status" :searchable="true" :options="selectActiveInative"
                                 :noOptionsText="noOptionsText" :noResultsText="noResultsText"/>
                </row-col-component>

                <row-col-component v-if="isClient"
                                   class-row-col="col-xxl-2 col-xl-2 col-lg-2 col-md-12 col-sm-12 col-12 mt-xxl-4 mt-0">
                    <button-submit class="me-2" @click="submit" icon="search"/>
                    <button-route v-if="buttonCheck.create" :items="itemsTwo"/>
                </row-col-component>
            </row-component>
        </form>

        <div class="alert alert-warning" role="alert" v-if="!isClient">
            <i class="exclamation triangle icon"></i>
            Selecione um cliente
        </div>

        <table class="table table-striped" v-if="showLoader && isClient">
            <thead>
            <tr>
                <th scope="col" style="width: 30%">Nome</th>
                <th scope="col" style="width: 30%">Criador</th>
                <th scope="col" style="width: 30%">Status</th>
                <th scope="col" style="width: 15%" v-if="buttonCheck.edit || buttonCheck.show">
                    Ações
                </th>
            </tr>
            </thead>

            <tbody>
            <tr v-for="(data, index) in object.data" :key="index">
                <td data-label="Nome">{{ data.name }}</td>
                <td data-label="Criador">
                    {{ data.creator_user_name === null ? "Methoduz" : data.creator_user_name }}
                </td>
                <td data-label="Status">{{ statusString(data.status) }}</td>
                <td data-label="Ações" v-if="buttonCheck.edit || buttonCheck.show">
                    <button-edit v-if="buttonCheck.edit" :id="data.id" route="spot-edit"/>
                    <button-show v-if="buttonCheck.show" :id="data.id" route="spot-show"/>
                </td>
            </tr>
            </tbody>
        </table>

        <button-pagination :pagination="object" :offset="3" @paginate="loadItems"/>
    </painel-component>
</template>

<script>
import PainelComponent from "@/components/dashboard/PainelComponent";
import RowComponent from "@/components/row/RowComponent";
import ButtonSubmit from "@/components/buttons/ButtonSubmit";
import ButtonEdit from "@/components/buttons/ButtonEdit";
import Multiselect from "@vueform/multiselect";
import InputComponent from "@/components/form/InputComponent";
import ButtonRoute from "@/components/buttons/ButtonRoute";
import RowColComponent from "@/components/row/RowColComponent";
import ButtonShow from "@/components/buttons/ButtonShow";
import ButtonPagination from "@/components/buttons/ButtonPagination";
import {useToast} from "vue-toastification";

const toast = useToast()

export default {
    name: "SpotSearch",
    components: {
        ButtonPagination,
        ButtonShow,
        RowColComponent,
        ButtonRoute,
        InputComponent,
        Multiselect,
        ButtonEdit,
        ButtonSubmit,
        RowComponent,
        PainelComponent
    },

    created() {
        this.$store.dispatch("changeNamePage", "Local")
        this.checkACL()
        this.loadStorage()
        this.loadItems(1)
    },

    data() {
        return {
            itemsOne: {
                icon: "list alternative",
                title: "Pesquisar"
            },

            itemsTwo: {
                icon: "plus",
                route: "/spot/create"
            },

            buttonCheck: {
                create: false,
                edit: false,
                show: false,
            },

            formData: {
                name: "",
                status: "",
                client_id: ""
            },

            showLoader: false,
            searchSubmit: false,
        }
    },

    methods: {
        submit() {
            this.loadItems(1)
            this.searchSubmit = true;
        },

        loadItems(page) {
            if (this.isClient){
                if (!this.searchSubmit) {
                    this.$store.dispatch("loadSpots", {...this.params, page})
                        .then((r) => {
                            if (this.searchSubmit) {
                                this.searchSubmit = false;
                                if (r.data.length === 0) {
                                    toast.info("Nada foi encontrado com os parâmetros informados!", {timeout: 1200});
                                }
                            }
                        }).catch(() => {
                        this.searchSubmit = false;
                    });
                }
            }
        },

        loadStorage() {
            this.$store.commit("IS_CLIENT", this.convertBool(localStorage.getItem("isClient")))
            this.$store.commit("ID_CLIENT", localStorage.getItem("id_client"))
            this.$store.dispatch("loadCompanyList", localStorage.getItem("id_client"))
        },

        convertBool(string) {
            return string === "true";
        },

        async checkACL() {
            this.$store.dispatch('ACLItems', 20)
                .then((r) => {
                    if (r.data.indexOf('spot-search') !== -1) {
                        this.showLoader = true
                        if (r.data.indexOf('spot-search') !== -1) {
                            this.buttonCheck.show = true
                        }

                        if (r.data.indexOf('spot-edit') !== -1) {
                            this.buttonCheck.edit = true
                        }

                        if (r.data.indexOf('spot-create') !== -1) {
                            this.buttonCheck.create = true
                        }
                    } else {
                        this.$router.push({name: 'home'})
                    }
                }).catch(() => {
                this.$router.push({name: 'home'})
            })
        },

        statusString(value) {
            if (parseInt(value) === 1)
                return "Ativo"
            return "Inativo"
        }
    },

    computed: {
        noOptionsText() {
            return this.$store.state.var.noOptionsText
        },

        noResultsText() {
            return this.$store.state.var.noResultsText
        },

        isClient() {
            return this.$store.state.var.isClient
        },

        idClient() {
            return this.$store.state.var.idClient
        },

        selectActiveInative() {
            return this.$store.state.var.selectActiveInative
        },

        object() {
            return this.$store.state.spot.items
        },

        params() {
            return {
                name: this.formData.name,
                status: this.formData.status,
                client_id: this.idClient
            }
        }
    },

    watch: {
        idClient(old, newValue) {
            this.loadItems(1)
            this.formData.client_id = newValue
        }
    }
}
</script>